import { useState, useRef, useEffect } from "react";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import classes from "./BankBankRecon.module.css";
import { Calendar } from "lucide-react";
import printer from "../../Assets/Printer.png";
import tick from "../../Assets/check.png";
import refresh from "../../Assets/ArrowsClockwise.png";
import save from "../../Assets/FloppyDisk.png";
import cancel from "../../Assets/X.png";
import uploadbtn from "../../Assets/UploadSimple.png";
import uploadicon from "../../Assets/uploadicon.png";
import downloadbtn from "../../Assets/DownloadSimple.png";
import chat from "../../Assets/ChatCircle.png";
import Footer from "../../Components/Footer/Footer";
import { Link, useNavigate } from "react-router";

const BankStatement = () => {
  const navigate = useNavigate();
  
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Current Month");
  const [isDragActive, setIsDragActive] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const inputRef = useRef(null);
  const fileInputRef = useRef(null);
  const wrapperRef = useRef(null);

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCalendarClick = (e) => {
    e.stopPropagation();
    inputRef.current.showPicker(); // shows native picker in modern browsers
  };

  const handleMonthChange = (e) => {
    const [year, month] = e.target.value.split("-");
    const monthName = new Date(e.target.value).toLocaleString("default", {
      month: "long",
    });
    setSelectedMonth(`${monthName} ${year}`);
  };

  const handleClickDropbox = () => {
    fileInputRef.current?.click();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      handleFiles(files);
    }
  };

  const handleFileInputChange = (e) => {
    if (e.target.files) {
      handleFiles(e.target.files);
    }
  };

  const handleFiles = (files) => {
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      const fileData = [];
      let filesRead = 0;

      fileArray.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          fileData.push({
            name: file.name,
            type: file.type,
            size: file.size,
            data: reader.result,
          });
          filesRead++;

          if (filesRead === fileArray.length) {
            console.log("Files selected:", fileData);
            setSelectedFiles(fileData);
            navigate("/accounting/bankstatement-preview", { state: { files: fileData } });
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };
  return (
    <div className={classes.bodyxyz}>
      <HeaderNav />
      <section className={classes.bankbody}>
        {/* <div className={classes.actions}>
          <Link to='/transactions/sales-invoice/sales'><button className={classes.btns}>Sales Invoice</button></Link>
          <Link to='/inventory/purchaseOrder'><button className={classes.btns}>Purchase order</button></Link>
          <button className={classes.btnst}>Reconcilation</button>
          <Link to='/settings/product-services'><button className={`${classes.btns} ${classes.greens}`}>Product & Services</button></Link>
        </div> */}

        <header className={classes.header}>
          <div className={classes.header1}>
            <h2 className={classes.Title}>Bank Statements</h2>
            <h1 className={classes.Titles}>
              Upload your bank statement to begin reconciliation. Review before submitting
            </h1>
          </div>
          {/*<div className={classes.header2}>
             <div className={classes.wrapper} ref={wrapperRef}>
              <div
                className={classes.combobox}
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <Calendar
                  className={classes.icon}
                  onClick={handleCalendarClick}
                />
                <span className={classes.label}>{selectedMonth}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={classes.chevron}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 011.1 1.02l-4.25 4.65a.75.75 0 01-1.1 0l-4.25-4.65a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
                <input
                  type="month"
                  ref={inputRef}
                  onChange={handleMonthChange}
                  className={classes.hiddenInput}
                />
              </div>
            </div> 
          </div>*/}
        </header>
      </section>
      <section className={classes.cardsect}>
        <div className={classes.reconciliationContainer}>
          <div 
            className={`${classes.dropboxfileupld} ${isDragActive ? classes.dragActive : ""}`}
            onClick={handleClickDropbox}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className={classes.dropbox}> 
              <img src={uploadicon} alt="Upload" className={classes.uploadIcon} />
              <p className={classes.dropboxText}>Upload your Bank Statement </p>
              <p className={classes.dropboxTextsmall}>Drag and drop your file here, or click to browse</p>
              <input 
                ref={fileInputRef}
                type="file" 
                className={classes.fileInput}
                onChange={handleFileInputChange}
                accept=".pdf,.csv,.xlsx,.xls"
              />
              <div className={classes.filetypes}>
                <p className={classes.filetypetxt}>PDF</p>
                <p className={classes.filetypetxt}>CSV</p>
                <p className={classes.filetypetxt}>XLSX</p>
                <p className={classes.filetypetxt}>Max 20MB</p>
              </div>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default BankStatement;
